



























































































import { Component, Prop } from "vue-property-decorator";
import InputProps from "@/mixins/InputProps";
import { getElement } from "@/lib/elementHelpers";
import { InputMaskOptions } from "@/modules/inputMask";
import BaseIcon from "@/components/BaseIcon";
import BaseInputBox from "@/components/BaseInputBox";
import ValidationProvider from "@/components/ValidationProvider";

@Component({
  name: "BaseInput",
  components: { BaseIcon, ValidationProvider, BaseInputBox },
})
export default class BaseInput extends InputProps {
  @Prop({ type: Object })
  public maskOpts!: InputMaskOptions | undefined;

  @Prop({ type: Boolean, default: false })
  public autofocus!: boolean;

  @Prop({ type: [String, Object, Array] })
  public fieldClass!: string | Record<string, boolean> | (string | Record<string, boolean>)[];

  public get formattedSymbolCount() {
    return `${this.value?.length ?? 0}/${this.maxlength}`;
  }

  public input(e: InputEvent) {
    this.$emit("input", (e.target as HTMLInputElement).value, e);
  }

  get opts() {
    if (this.maskOpts) {
      return {
        onBeforePaste: (value: string) => {
          this.$emit("input", value);
        },
        ...this.maskOpts,
      };
    }
    return undefined;
  }

  get hasPrepend() {
    return !!this.prependIcon || !!this.$scopedSlots.prependIcon;
  }

  get hasSecondPrepend() {
    return !!this.secondPrependIcon || !!this.$scopedSlots.secondPrependIcon;
  }

  get hasAppend() {
    return !!this.appendIcon || !!this.$scopedSlots.appendIcon;
  }

  public onValidation(...v: any[]) {
    this.$emit("validation", ...v);
  }
  public mounted() {
    if (this.autofocus) {
      const input = getElement<HTMLInputElement>(this.$refs.input);
      input.focus();
    }
  }
}
